module.exports = __webpack_public_path__ + "img/neumatico.41299bd7.svg";